import React from 'react';

const EventModal = ({ show, onClose, event, onChange, onSubmit, loading, isEdit }) => {
  if (!show) return null;

  // defensive defaults so EventModal never crashes if `event` is undefined
  const evt = event || {
    eventName: '',
    eventType: 'academic',
    customEventType: '',
    startDate: '',
    endDate: '',
    description: '',
  };

  const handleChange = (field, value) => {
    if (typeof onChange === 'function') {
      onChange({ ...evt, [field]: value });
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60 p-4">
      <div className="bg-white rounded-3xl shadow-2xl w-full max-w-lg max-h-[90vh] overflow-hidden flex flex-col">
        <div className="flex items-center justify-between p-5 border-b">
          <div>
            <h3 className="text-xl font-semibold text-gray-900">{isEdit ? 'Edit Event' : 'Add Event'}</h3>
            <p className="text-sm text-gray-600">Manage calendar event details</p>
          </div>
          <button onClick={onClose} className="p-2 text-gray-500 hover:text-gray-700 rounded">
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        <form onSubmit={onSubmit} className="flex-1 overflow-y-auto p-6 space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Event Name</label>
            <input
              type="text"
              value={evt.eventName}
              onChange={(e) => handleChange('eventName', e.target.value)}
              required
              className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Start Date</label>
              <input
                type="date"
                value={evt.startDate}
                onChange={(e) => handleChange('startDate', e.target.value)}
                required
                className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">End Date</label>
              <input
                type="date"
                value={evt.endDate}
                onChange={(e) => handleChange('endDate', e.target.value)}
                required
                className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Event Type</label>
            <select
              value={evt.eventType}
              onChange={(e) => handleChange('eventType', e.target.value)}
              className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option value="academic">Academic</option>
              <option value="holiday">Holiday</option>
              <option value="exam">Exam</option>
              <option value="administritive">Administrative</option>
              <option value="other">Other</option>
            </select>
          </div>

          {/* Custom Event Type when "Other" selected */}
          {evt.eventType === 'other' && (
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Specify Event Type</label>
              <input
                type="text"
                value={evt.customEventType || ''}
                onChange={(e) => handleChange('customEventType', e.target.value)}
                required
                placeholder="e.g. Staff Training"
                className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
          )}

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Description</label>
            <textarea
              value={evt.description}
              onChange={(e) => handleChange('description', e.target.value)}
              rows={4}
              className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
        </form>

        <div className="p-4 border-t flex gap-3">
          <button
            onClick={onClose}
            type="button"
            className="flex-1 px-4 py-2 bg-gray-100 rounded-lg hover:bg-gray-200 font-semibold"
          >
            Cancel
          </button>
          <button
            type="submit"
            onClick={onSubmit}
            disabled={loading}
            className={`flex-1 px-4 py-2 rounded-lg text-white font-semibold ${
              loading ? 'bg-gray-400 cursor-not-allowed' : 'bg-blue-600 hover:bg-blue-700'
            }`}
          >
            {loading ? 'Saving...' : (isEdit ? 'Save Changes' : 'Add Event')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default EventModal;